export const StorageKeys = {
  preferences: 'preferences',
  metadata: 'metadata',
  user: 'user',
  agGrid: 'agGrid'
};
